import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Globe14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_99)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7ZM7 1.75C6.26981 1.75 5.57444 1.89907 4.94266 2.16843C5.65695 2.43663 6.7336 2.86251 6.78065 3.76502C6.82949 4.70188 5.78235 5.10787 5.1221 5.52754L5.1248 5.52754C5.78101 5.52825 6.48204 5.5492 7.03131 5.95719C7.54087 6.33568 7.79466 7.00715 7.74804 7.6332C7.67043 8.67542 7.45623 9.70292 7.11096 10.6893C6.722 11.8726 5.4406 11.4604 4.90299 10.6675C4.53196 10.1203 4.00121 9.25001 3.25011 9.25001C2.85741 9.25001 2.50971 9.20968 2.20315 9.13693C3.02161 10.9714 4.86149 12.25 7 12.25C8.37543 12.25 9.62731 11.7211 10.5634 10.8555C10.824 10.3173 10.811 10.0185 10.7665 9.85763C10.6048 9.27231 9.7918 8.96415 9.35078 8.63365C9.04027 8.40096 8.58295 7.99981 8.52654 7.35811C8.43176 6.64613 8.64429 5.92373 9.15901 5.40901C9.58097 4.98705 10.1533 4.75 10.75 4.75H11.7448C10.9022 2.97629 9.0943 1.75 7 1.75ZM12.1968 6.25H10.75C10.3547 6.25 10.004 6.59762 10 6.99253C10.0204 7.74586 11.5144 8.21078 11.9232 8.82747C12.2274 8.00833 12.3205 7.1146 12.1968 6.25ZM1.75 6.99891C1.75029 5.54774 2.33937 4.23415 3.29134 3.28404C3.8912 3.37075 4.4726 3.55805 5.01091 3.83843C4.35232 4.2313 3.27592 4.70939 3.17421 5.57841C3.10921 6.13384 3.4474 6.69128 3.96528 6.8923C4.58051 7.13111 6.23479 6.52356 6.24992 7.55158C6.19916 8.20788 6.08644 8.85738 5.91355 9.49144C5.27717 8.60589 4.41845 7.75001 3.25011 7.75001C2.68492 7.75001 1.90502 7.64416 1.75 6.99891Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_99'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Globe14.displayName = 'Globe14';
export default Globe14;
